
import {Vue, Prop, Component} from "vue-property-decorator";
import {Getter} from "vuex-class";
import RightsForm from "@/components/rights/RightsForm.vue";
import { canEditUserRights } from "@/services/rights";

@Component({
    components: { RightsForm },
})
export default class EditDefaultRights extends Vue {

    get currentRole(): "MANAGERS" | "GUESTS" {
      return this.currentTab === "management" ? "MANAGERS" : "GUESTS";
    }

    get canEditDefaultRights(): boolean {
      return canEditUserRights(this.currentUser, this.currentRole);
    }

    @Prop({default: ""})
    public currentTab: string;

    @Prop({default: null})
    public companyId: number;

    public $refs!: {
      rightsForm: any,
    };

    @Getter private currentUser: any;
    @Getter private isAdmin: boolean;

    private isEdit: boolean = false;
    private updateOldUser: boolean = false;
    private valid: boolean = true;
    private loading: boolean = false;
    private rights: any[] = [];
    private defaultRights: any[] = [];
    private rightsToSave: any[] = [];
    private applyToExistingUsers: boolean = false;

    private async mounted(): Promise<void> {
      if (this.canEditDefaultRights) {
        await Promise.all([
            this.getRights(),
            this.getDefaultRights(),
        ]);
      }
    }

    private closeEdit(): void {
        this.isEdit = false;
        this.updateOldUser = false;
        this.applyToExistingUsers = false;
    }

    private changeTab(): void {
        // Save rights for update query later
        this.rightsToSave = this.$refs.rightsForm.currentRights
          .filter((r) => r.isChecked).map((r) => r.id);
        this.isEdit = false;
        this.updateOldUser = true;
    }

    private save(): Promise<any> {
        this.loading = true;
        return this.$store.dispatch("rights/saveCompanyDefaultRights", {
            applyToExistingUsers: this.applyToExistingUsers,
            companyId: this.companyId,
            type: this.currentRole,
            rights: this.rightsToSave,
        }).then((res) => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("actions.saved"),
            });
            this.getDefaultRights();
            this.closeEdit();
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err?.response?.data?.error || err,
            });
        }).finally(() => this.loading = false);
    }

    private getRights(): Promise<any> {
        return this.$store.dispatch("rights/getAllRights").then((res) => {
            this.rights = JSON.parse(JSON.stringify(res.rights));
        });
    }

    private async getDefaultRights(): Promise<void> {
      this.defaultRights = await this.$store.dispatch("rights/getCompanyDefaultRights", {
        companyId: this.companyId,
        type: this.currentRole,
      }).then((res) => res.rights);
    }

}
